export default "__VITE_ASSET__BIvARMoo__"